import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getCurrentRichContent } from "../helpers/richContentHelpers";

const eventsPageTplData = (id) => {
    const data = useStaticQuery(
        graphql`
            {
                allWpPage {
                    edges {
                        node {
                            id
                            template {
                                ... on WpTemplate_Events {
                                    eventsRichContent {
                                        # SECTION: Page Header
                                        pageHeader {
                                            title
                                            text
                                        }

                                        # SECTION: Posts List
                                        postsList {
                                            postsPerPage
                                        }

                                      # SECTION: FAQ
                                      faqSection {
                                        header
                                        items {
                                          question
                                          answer
                                        }
                                    }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    );

    return getCurrentRichContent(data, id, "eventsRichContent");
};

export { eventsPageTplData };
